import { ProgressView } from "@gaming/srvg-classes-core";

export class ProgressbarView extends ProgressView {
    constructor( options ) {
        options = options || {};
        options.name = options.name || 'progressbarView';
        super( options );
    }
}